import { useState } from 'react';
import s from './AddCourseLesson.module.scss';
import ImageIcon from "../../../../../../../../assets/icons/image.svg"
import VideoIcon from "../../../../../../../../assets/icons/video.svg"
import { StyledHTMLFieldsBlock } from 'components/StyledHTMLFiledsBlock/StyledHTMLFieldsBlock';
import { FileManager } from 'components/FileManager/FileManager';
import { ModalGeneral } from 'components/Modals/ModalGeneral';
import { useTranslation } from 'react-i18next';
import questionMark from "assets/images/questionMark.webp";
import { AddLinkModal } from './AddLinkModal/AddLinkModal';
import { clearHTML } from 'utils/clearHTML';
import { ReactComponent as DeleteIcon } from "../../../../../../../../assets/icons/delete_icon2.svg"
import { ImageInput } from 'components/ImageInput/ImageInput';

export const AddCourseLesson = ({data, form, setForm, currentModule, activeLang, setActiveLang, setCurrentLesson, setDeletedLessons}: any) => {

    // ### State
    const [storage, setStorage] = useState<boolean>(false)
    const [storageVideo, setStorageVideo] = useState<boolean>(false)
    const [showDeleteModal, setShowDeleteModal] = useState<any>(false);
    const [showDeleteLinkModal, setShowDeleteLinkModal] = useState<any>(false);
    const [showLinksModal, setShowLinksModal] = useState<any>(false)

    const {t} = useTranslation()

    // ### Effects

    // ### Functions

    function changeModuleText(key: any, value: any){
        setForm((prev: any) => {
            return {
                ...prev,
                modules: prev.modules?.map((mod: any) => {
                    if(mod.id === currentModule.id){
                        return {
                            ...mod,
                            lessons: mod.lessons?.map((les: any) => {
                                if(les.id === data.id){
                                    return {
                                        ...les,
                                        [key]: {...les[key], ...value}
                                    }
                                } else return les
                            })
                        }
                    } else return mod
                })
            }
        })
    }

    function changeModuleImage(key: string, value: string){
        setForm((prev: any) => {
            return {
                ...prev,
                modules: prev.modules?.map((mod: any) => {
                    if(mod.id === currentModule.id){
                        return {
                            ...mod,
                            lessons: mod.lessons?.map((les: any) => {
                                if(les.id === data.id){
                                    return {
                                        ...les,
                                        [key]: value
                                    }
                                } else return les
                            })
                        }
                    } else return mod
                })
            }
        })
    }

    function deleteLesson(id: number){
        setForm((prev: any) => ({
            ...prev,
            modules: prev.modules?.map((mod: any) => {
                if(mod.id === currentModule.id){
                    return {
                        ...mod,
                        lessons: mod.lessons?.filter((les: any) => les.id !== id)
                    }
                } else return mod
            })
        }))
        setCurrentLesson(form.modules?.find((mod: any) => mod.id === currentModule?.id)?.lessons?.[0])
        setDeletedLessons((prev: any) => {
            return [...prev, id]
        })
    }

    function DeleteLink(id: number){
        setForm((prev: any) => ({
            ...prev,
            modules: prev?.modules?.map((mod: any) => {
                if(mod.id === currentModule.id){
                    return {
                        ...mod,
                        lessons: mod.lessons?.map((les: any) => {
                            if(les.id === data.id){
                                return {
                                    ...les,
                                    links: les.links?.filter((link: any) => link.id !== id)
                                }
                            } else return les
                        })
                    }
                }else return mod
            })
        }))
    }

    // ### Views

    const linksView = form.modules?.find((mod: any) => mod.id === currentModule?.id)?.lessons?.find((les: any) => les.id === data.id)?.links?.map((link: any, index: number) => {
        return(
            <div className={s.link} key={index}>
                <span className={s.link_url}>{link?.link}</span>
                <span className={s.link_title}>{clearHTML(link.title?.[activeLang])}</span>
                <div className={s.delete} onClick={() => setShowDeleteLinkModal(link.id)}><DeleteIcon/></div>
            </div>
        )
    })

    return(
        <div className={s.module_wrapper}>

            <div className={s.buttons_wrapper}>
                <div 
                    className={s.add_button} 
                    onClick={() => setShowDeleteModal(data.id)}
                >{t('courses.delete_lesson')}</div>
            </div>
            
            <div className={s.video_wrapper}>
                <div className={s.image_wrapper}>
                    <ImageInput 
                        values={form.modules?.find((mod: any) => mod.id === currentModule?.id)?.lessons?.find((les: any) => les.id === data.id)?.preview}
                        setValues={(value: any) => {
                            setForm((prev: any) => ({
                                ...prev,
                                modules: prev.modules?.map((mod: any) => {
                                    if(mod.id === currentModule.id){
                                        return {
                                            ...mod,
                                            lessons: mod.lessons?.map((les: any) => {
                                                if(les.id === data.id){
                                                    return {
                                                        ...les,
                                                        preview: {...les.preview, ...value}
                                                    }
                                                }
                                                else return les
                                            })
                                        }
                                    } 
                                    else return mod
                                })
                            }))
                        }}
                        setIsManual={(value: any) => {
                            setForm((prev: any) => ({
                                ...prev,
                                modules: prev.modules?.map((mod: any) => {
                                    if(mod.id === currentModule.id){
                                        return {
                                            ...mod,
                                            lessons: mod.lessons?.map((les: any) => {
                                                if(les.id === data.id){
                                                    return {
                                                        ...les,
                                                        preview: {
                                                            ...les.preview,
                                                            isManual: value
                                                        }
                                                    }
                                                }
                                                else return les
                                            })
                                        }
                                    } 
                                    else return mod
                                })
                            }))
                        }}
                        setDefault={(value: any) => {
                            setForm((prev: any) => ({
                                ...prev,
                                modules: prev.modules?.map((mod: any) => {
                                    if(mod.id === currentModule.id){
                                        return {
                                            ...mod,
                                            lessons: mod.lessons?.map((les: any) => {
                                                if(les.id === data.id){
                                                    return {
                                                        ...les,
                                                        preview: {
                                                            ...les.preview,
                                                            default_image: value
                                                        }
                                                    }
                                                }
                                                else return les
                                            })
                                        }
                                    } 
                                    else return mod
                                })
                            }))
                        }}
                    />
                </div>
                <div className={s.image_wrapper}>
                    <ImageInput 
                        values={form.modules?.find((mod: any) => mod.id === currentModule?.id)?.lessons?.find((les: any) => les.id === data.id)?.video}
                        type={"video"}
                        setValues={(value: any) => {
                            setForm((prev: any) => ({
                                ...prev,
                                modules: prev.modules?.map((mod: any) => {
                                    if(mod.id === currentModule.id){
                                        return {
                                            ...mod,
                                            lessons: mod.lessons?.map((les: any) => {
                                                if(les.id === data.id){
                                                    return {
                                                        ...les,
                                                        video: {...les.video, ...value}
                                                    }
                                                }
                                                else return les
                                            })
                                        }
                                    } 
                                    else return mod
                                })
                            }))
                        }}
                        setIsManual={(value: any) => {
                            setForm((prev: any) => ({
                                ...prev,
                                modules: prev.modules?.map((mod: any) => {
                                    if(mod.id === currentModule.id){
                                        return {
                                            ...mod,
                                            lessons: mod.lessons?.map((les: any) => {
                                                if(les.id === data.id){
                                                    return {
                                                        ...les,
                                                        video: {
                                                            ...les.video,
                                                            isManual: value
                                                        }
                                                    }
                                                }
                                                else return les
                                            })
                                        }
                                    } 
                                    else return mod
                                })
                            }))
                        }}
                        setDefault={(value: any) => {
                            setForm((prev: any) => ({
                                ...prev,
                                modules: prev.modules?.map((mod: any) => {
                                    if(mod.id === currentModule.id){
                                        return {
                                            ...mod,
                                            lessons: mod.lessons?.map((les: any) => {
                                                if(les.id === data.id){
                                                    return {
                                                        ...les,
                                                        video: {
                                                            ...les.video,
                                                            default_image: value
                                                        }
                                                    }
                                                }
                                                else return les
                                            })
                                        }
                                    } 
                                    else return mod
                                })
                            }))
                        }}
                    />
                </div>
            </div>
            <div className={s.item}>
                <StyledHTMLFieldsBlock 
                    title={t('courses.lesson_name')} 
                    values={form.modules?.find((mod: any) => mod.id === currentModule?.id)?.lessons?.find((les: any) => les.id === data.id)?.name }
                    changeValue={val => changeModuleText("name", val)} 
                    setLang={() => {}} 
                    activeLang={activeLang}
                    setActiveLang={setActiveLang}
                    height={150}
                />
            </div>
            <div className={s.item}>
                <StyledHTMLFieldsBlock 
                    title={t('courses.lesson_description')} 
                    values={form.modules?.find((mod: any) => mod.id === currentModule?.id)?.lessons?.find((les: any) => les.id === data.id)?.description }
                    changeValue={val => changeModuleText("description", val)} 
                    setLang={() => {}} 
                    activeLang={activeLang}
                    setActiveLang={setActiveLang}
                    height={400}
                />
            </div>
            <div className={s.links_wrapper}>
                <span className={s.links_title}>{t('courses.links')}</span>
                <div className={s.links}>
                    {linksView}
                </div>
                    <div 
                        className={s.add_link_button} 
                        onClick={() => setShowLinksModal(true)}
                    >{t('courses.add_link')}</div>
                
            </div>
            {
                showLinksModal ?
                <AddLinkModal 
                    data={showLinksModal}
                    activeLang={activeLang}
                    setActiveLang={setActiveLang}
                    setForm={setForm}
                    currentModule={currentModule}
                    currentLesson={data}
                    hide={()=> setShowLinksModal(false)}
                /> : null
            }
            {
                storage ? 
                <FileManager 
                    isModal={true}
                    type={"image"}
                    setIsOpenStorage={() => setStorage(false)}
                    setFile={(link) => changeModuleImage("preview", link)}
                /> : null
            }
            {
                storageVideo ? 
                <FileManager 
                    isModal={true}
                    type={"video"}
                    setIsOpenStorage={() => setStorageVideo(false)}
                    setFile={(link) => changeModuleImage("video", link)}
                /> : null
            }

            <ModalGeneral
                showModal={showDeleteModal}
                setShowModal={setShowDeleteModal}
                title={t("general.delete")}
                textLeftButton={t("general.cancel")}
                textRightButton={t("general.delete")}
                image={questionMark}
                description={`${t("general.areYouSure")}? ${t("general.itsContents")}`}
                buttonRight={() => deleteLesson(showDeleteModal)}
            />

            <ModalGeneral
                showModal={showDeleteLinkModal}
                setShowModal={setShowDeleteLinkModal}
                title={t("general.delete")}
                textLeftButton={t("general.cancel")}
                textRightButton={t("general.delete")}
                image={questionMark}
                description={`${t("general.areYouSure")}? ${t("general.itsContents")}`}
                buttonRight={() => DeleteLink(showDeleteLinkModal)}
            />
        </div>
    )
}